import React from 'react';
import { makeStyles } from '~/UIKit/Style';
import IphoneFrame from '~/Assets/Images/Placeholders/mobile_frame.png';

const FRAME_HEIGHT = 450;

const useStyles = makeStyles((theme) => ({
  previewInPhoneContainer: {
    position: 'relative',
    maxWidth: FRAME_HEIGHT / 2,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  phoneFrameContainer: {
    overflow: 'hidden',
    '&>img': {
      width: 'auto',
      height: FRAME_HEIGHT,
    },
  },
  phoneContent: {
    position: 'absolute',
    top: 13,
    left: 15,
    height: FRAME_HEIGHT - 25,
    maxWidth: FRAME_HEIGHT / 2 - 30,
    minWidth: FRAME_HEIGHT / 2 - 30,
    borderRadius: 20,
    overflow: 'hidden auto',
    '&::-webkit-scrollbar': {
      width: 0,
    },
  },
}));

interface IPreviewInPhoneProps {
  children: React.ReactNode;
  contentRef: React.RefObject<HTMLDivElement>;
}

export const PreviewInPhone = ({ children, contentRef }: IPreviewInPhoneProps) => {
  const { classes } = useStyles();
  return (
    <div className={classes.previewInPhoneContainer}>
      <div className={classes.phoneFrameContainer}>
        <img src={IphoneFrame} />
      </div>
      <div className={classes.phoneContent} ref={contentRef}>
        {children}
      </div>
    </div>
  );
};
